import reducer from './reducer';

export const {
  logout,
  resetAdminCodeAttempt,
  resetSchedule,
  setSchedule,
  setCookies,
  setLoginData,
  setNotFound,
  clearCodeLoginError,
  dismissMobilityWarning,
} = reducer.actions;
